window.OFFSET = window.OFFSET || {};
window.OFFSET['consent'] = {
    version: "2026-06-01",
    showReopenButton: false,
};
